"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/template-a/template-a.scss');
/*import { Init, InitReact, ImportCoreweb } from './../js/index';*/
const index_1 = require("./../js/index");
const template_a_1 = require("./Sites/template-a");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, template_a_1.InitTemplateA)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
/*InitReact();*/ 
